import React from 'react';
import "styles/scss/lab/pages/dashboard.scss";
import { gql, useQuery, useMutation } from '@apollo/client';
import API_CALLS from 'API_CALLS/index';
import TemplateList from 'global/templates/templateLists/index';

import TPOfferList from 'user/lab/components/TPOfferList/index';
import TPFullList from 'user/lab/components/TPFullList/index';

import ESPAÑOL from "./ESPAÑOL";
import ENGLISH from "./ENGLISH";
import LayoutBuilder from 'LayoutBuilder';


const CONTENTS = {
  ESPAÑOL,
  ENGLISH
}
const MUTATION_USER_EDIT = API_CALLS.USERS.MUTATIONS.update();
const {Container, Row, Column} = LayoutBuilder;


class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }; 
  }

  componentDidMount(){
  }

  componentWillUnmount(){
  }


  render(){
    var {showSideMenu} = this.state;
    var currentUser = (window.Session.user ? window.GlobalUtil.stripOutFromObj(window.Session.user, "__typename") : {});
    var {userPicture, progressPictures=[], address={}, firstName, lastName, phone, confirmedEmail, id, userFlowStatus=1} = currentUser;
    const CONTENT = window.GlobalUtil.dangerSetGlobal(CONTENTS[window.Session.Language]); 
    //console.log(`CONTENT`,"\n\n",CONTENT,"\n\n");
          
    const confirmDic = {
      "ENGLISH": "Yes",
      "ESPAÑOL": "Si"
    }
    return (
      <div id="LabHome" className="scrollZone">
        <div className="">
          <Container className="" fluid="true">
            <Row className="">
              <Column className="" col="" xs="" sm="" md="" lg="" xl="">
                <div className="headerButton">
                  <h1 className="pageHeader"><i className="fas fa-tachometer-alt"></i> {CONTENT[0]}</h1>
                </div>
              </Column>
            </Row>
          </Container> 
          <Container className="" fluid="true">
            <Row className="">
              <Column className="matchHeight" col="" xs="" sm="" md="12" lg="12" xl="12">
                <div className="component fullHeight overflowRightScroll">
                  <div className="itemHeader d-flex">
                    <div className="itemHeaderTextZone">
                      {CONTENT[1]}
                    </div>
                  </div>
                  <TPOfferList />
                </div>
              </Column>
            </Row>

            <Row className="">
              <Column className="matchHeight" col="" xs="" sm="" md="12" lg="12" xl="12">
                <div className="component fullHeight overflowRightScroll">
                  <div className="itemHeader d-flex">
                    <div className="itemHeaderTextZone">
                      {CONTENT[2]}
                    </div>
                  </div>
                  <TPFullList />
                </div>
              </Column>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}



















export default Index;